import React from 'react';
import { CheckboxField } from '@zola/zola-ui/src/components/Form/CheckboxField';

interface ReceptionMenuProps {
  activeValue: boolean;
  updateFilter: (filter: 'is_vow_renewal', value: boolean) => void;
}

export const ReceptionMenu: React.FC<ReceptionMenuProps> = ({ activeValue, updateFilter }) => {
  return (
    <CheckboxField
      label="Only show elopement & vow renewal designs."
      id="reception-menu"
      checked={activeValue}
      onChange={() => updateFilter('is_vow_renewal', !activeValue)}
      meta={{ touched: true }}
    />
  );
};
